import { extendTheme } from "@chakra-ui/react";

/** Alineado con `tailwind.config.js` — principal / secundario / terciario. */
export const chakraTheme = extendTheme({
  colors: {
    brand: {
      50: "#faf8fb",
      100: "#f1e9f5",
      200: "#e2d0e8",
      300: "#c8a5ce",
      400: "#9a6a9e",
      500: "#31023C",
      600: "#280230",
      700: "#1f0128",
      800: "#16011c",
      900: "#0e0012",
    },
  },
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
});
